import React from 'react';
  import axios2 from 'services/axios2';

  import {useParams, Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import NuDropdown from 'components/nubox/NuDropdown';
  import ImageUploadSingle from 'components/nubox/ImageUploadSingle';
  
  import { useStore, useDispatch } from "store/StoreProvider";

  //import listac from '../assets/img/lista2.png';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from 'reactstrap';

  const initialForm = {
    idd:0,
    ope:'n',
        
    id_inscrip:0,

    id_peri:0,
    id_est:0,
    id_carre:0,
    estudiante:'',
    periodo:'',   

  };
  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class ModalEstCarrera extends React.Component {
    state = {
      modalInsertar:false,
      form: Object.assign({}, initialForm),
      
      carreras:[], /* combo grupos */
    };
    //------------------------------------------------------
    componentDidMount() {
      console.log('componentDidMount Modal');
      //--limpiamos el array de prueba
          
      //---------
      //this.limpiar();

      this.cargar_carreras();
    }
    //-------------------
    limpiar = () =>{
      let newForm= Object.assign({}, initialForm);
      this.setState({form: newForm });
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    //----cargamos combo
    //----cargamos combo
    cargar_carreras = async() => {
      let param = { }
      await axios2.post('cbo_carrera', param).then(res => {
          if(res.data.length>0){ 
              //this.setState({materias: res.data, });
              console.log("res.data[0]")
              console.log(res.data[0].value)
              this.setState({
                carreras: res.data,               
              });
              //añadimos el id y ope
              this.setState({
                form: {  ...this.state.form, 
                  id_carre: res.data[0].value,  
                  carrera: res.data[0].label,
                },
              });

          }else{
            toast.error('No existen datos');
          }
      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
      });
      //--- colocamos el primer elemento como 
      
      
    };
    //======================================================
    showModal = () => {
      //setModalOpen(true);
      this.setState({ modalInsertar: true});
    }
    closeModal = () => {
      //setModalOpen(true);
      this.setState({ modalInsertar: false});
    }
    //---------------
    // item value,label
    nuevo =(id_est, estudiante, id_peri, periodo) =>{
      console.log('nuevo');
      //this.limpiar();
      
      //let id_peri = this.props.store.user.id_peri;
      //let periodo = this.props.store.user.periodo;
     
      this.setState({
        form: {
          ...this.state.form,
          idd: 0,
          ope:'n',
          id_est: id_est,
          estudiante: estudiante,
          id_peri: id_peri,
          periodo: periodo,
        },
        modalInsertar: true,
      });
    }
    //------------------------------------------------
    editar =(idd, id_peri, periodo)=>{
      console.log('editar');
      let param = { idd: idd, ope:'f'  }
      
      console.log(param)
      axios2.post( 'inscribir_est_x_ci_store' , param).then(res => {
        console.log(res.data);

          if(res.data !== null){               
              //---asignamos los valores
              //...res.data,
              this.setState({
                form: {
                  ...this.state.form,
                  'idd': idd,
                  'ope': 'e',
                  'id_est':res.data.id_est,
                  'estudiante':res.data.estudiante,
                  'id_preins':res.data.id_preins,
                  'id_carre':res.data.id_carre,
                  id_peri: id_peri,
                  periodo: periodo,
                },
                modalInsertar: true, /* show modal */
              });

              //----
          }else{
            toast.error('No existen datos');
          }

      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
          
      });
    }
    //----------------------------
    eliminar =(idd)=>{
      console.log('eliminar');
      let param = { 
        idd: idd,
        ope:'x'
      }
      //console.log(param);
      axios2.post( 'inscribir_est_x_ci_store', param).then(res => {
        console.log(res.data);
  
          if(res.data.exito===1){ 
              this.limpiar();
              this.closeModal();
              toast.success('Eliminado con exito');
              this.props.okModal(); //callback
          }else{
            toast.error('Error al eliminar registro', {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
          
      });
    }
    //----------------------------
    validar = () =>{
      if( this.state.form.id_espe===0){
        toast.error( 'Especialidad no valido', {position: toast.POSITION.TOP_RIGHT});
        return true;
      }
    }
    /************************************************ */
   
    //----------------------------
    formSave = () => {
      /*let error = this.validar();
      if(error===true){
        return;
      }*/
      
      let param = this.state.form;
      console.log("param");
      console.log(param);
  
      axios2.post('inscribir_est_x_ci_store', param).then(res => {
          let response = res.data;
        
          if(response.exito===1){ 
              
            toast.success( response.men, {position: toast.POSITION.TOP_RIGHT});
            //---llamamos a la funcion externa
            this.props.okModal();
            this.closeModal();
          }else{
  
            toast.error( response.men, {position: toast.POSITION.TOP_RIGHT});
          }
  
      }).catch(error => {
          alert('Bad Request');
          console.log(error);
          
      });
  
    }
    //---------------------------
    render() {
      const form= this.state;

      return (
        <div>
          <ToastContainer />
          
          {/*--- modal---- */}
          <Modal isOpen={this.state.modalInsertar} toggle={this.closeModal} >
            <ModalHeader toggle={this.closeModal} 
              className= { (this.state.form.ope==='n'? 'header-verde':'header-naranja') + ' ' + (this.state.form.ope==='n'? "color:'#45b545'":"color:'#343b43'")  } 
            >
              <h4 className="modal-title">
              { this.state.form.ope==='n'
                ? "Nuevo"
                : "Editar"
              }
              </h4>
              {
                //JSON.stringify(this.state.form)
              }
            </ModalHeader>
  
            <ModalBody style={{background: "#F7F7F7"}}>
            {
              //JSON.stringify(this.state.form )
            }                      
            <form  method='POST'> 
                <div>
                  <table align='center' width="100%" className="tabla04">
                  
                      {/*<tr>
                          <td width="20%" className="color_azul">id_doc_mat:</td>
                          <td >
                            <input
                              type='text'
                              name='id_doc_mat'
                              value={this.state.form.id_doc_mat}
                              onChange={this.handleChangeForm}
                              className='form-control'
                              disabled
                            />
                          </td>
                      </tr>*/}
                      
                      <tr>
                          <td  width="20%" className="color_azul">Estudiante:</td>
                          <td > 
                            <label>
                              { this.state.form.estudiante }
                            </label>
                          </td>
                      </tr>
                      
                      <tr>
                          <td width="20%" className="color_azul">Carrera:</td>
                          <td > 
                          <NuDropdown
                            options={this.state.carreras}
                            name='id_carre'
                            value={ this.state.form.id_carre}
                            onChange={this.handleChangeForm}
                          /> </td>
                      </tr>
                      <tr>
                          <td width="20%" className="color_azul">Periodo:</td>
                          <td > 
                          <span>
                            { this.state.form.periodo }
                          </span>
                          </td>
                      </tr>
                      
                  </table>  
                </div>
              </form>
        
              
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={ this.formSave}>Guardar</Button>{' '}
              <Button color='secondary' onClick={this.closeModal}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
  }
  
  //------------
  export default ModalEstCarrera;